export default "__VITE_ASSET__BnjHwDJx__"